// Comprehensive Mock Reports Data
// Based on database seed.sql structure - for demo purposes only

import { getReportModulesByType } from './reportConfiguratorBlocks';

const buildDefaultTabs = () => ({
  evidence: { content: null, status: 'not_started' },
  ai: { content: null, status: 'not_started' },
  review: { content: null, status: 'not_started' },
});

// Helper to generate default modules array with tabs structure
export const generateDefaultModules = (reportType = 'relazione_agronomica_primo_anno') => {
  const moduleDefinitions = getReportModulesByType(reportType);
  return moduleDefinitions.map(module => ({
    id: module.id,
    name: module.fallbackName || module.id,
    status: 'not_started',
    tabs: buildDefaultTabs(),
  }));
};

export const MOCK_REPORTS = [];

// For the ReportsPage component
export const mockPastReports = MOCK_REPORTS;

// Helper functions
export const getReportsByStatus = (status) => {
  return MOCK_REPORTS.filter(r => r.status === status);
};

export const getReportsByYear = (year) => {
  return MOCK_REPORTS.filter(r => r.year === year);
};

export const addMockReport = (report) => {
  if (!report || !report.id) {
    return;
  }
  const existingIndex = MOCK_REPORTS.findIndex(r => r.id === report.id);
  if (existingIndex >= 0) {
    MOCK_REPORTS[existingIndex] = report;
    return;
  }
  MOCK_REPORTS.unshift(report);
};

export const getReportById = (id) => {
  return MOCK_REPORTS.find(r => r.id === id);
};

export const getReportsKPIs = () => {
  const currentYear = new Date().getFullYear();
  const currentYearReports = MOCK_REPORTS.filter(r => r.year === currentYear);
  
  return {
    totalReports: MOCK_REPORTS.length,
    reportsInProgress: MOCK_REPORTS.filter(r => ['draft', 'in_progress', 'needs_review'].includes(r.status)).length,
    completedReports: currentYearReports.filter(r => r.status === 'completed').length,
    // Keep backward compatibility
    total: MOCK_REPORTS.length,
    inProgress: MOCK_REPORTS.filter(r => ['draft', 'in_progress', 'needs_review'].includes(r.status)).length,
    completed: currentYearReports.filter(r => r.status === 'completed').length,
  };
};

